// EdKonect Mock Data

export const companyInfo = {
  name: "EdKonect",
  tagline: "Integrated Campus Management System",
  description: "Empowering schools with smart technology to manage, connect, and grow.",
  email: "hello@edkonect.com",
  phone: "+91 8179070606",
  appUrl: "https://app.edkonect.com",
  owner: "Intelvolks"
};

export const stats = [
  { id: 1, value: "100+", label: "Schools", icon: "School" },
  { id: 2, value: "10K+", label: "Students", icon: "Users" },
  { id: 3, value: "5K+", label: "Teachers", icon: "GraduationCap" },
  { id: 4, value: "4+", label: "States", icon: "MapPin" },
  { id: 5, value: "99.9%", label: "Uptime", icon: "Shield" },
  { id: 6, value: "24/7", label: "Support", icon: "Headphones" }
];

export const features = [
  {
    id: 1,
    title: "Admission Module",
    description: "Complete admission lifecycle management from enquiry to exit with document management, student movement tracking, and insightful statistics.",
    icon: "UserPlus"
  },
  {
    id: 2,
    title: "Finance Module",
    description: "Flexible fee configuration, online payments via integrated gateway, auto-generated receipts, real-time dashboards, and automated reminders.",
    icon: "CreditCard"
  },
  {
    id: 3,
    title: "Staff Management",
    description: "Complete staff lifecycle from onboarding to exit with detailed profiles, department mapping, academic assignments, and clearance management.",
    icon: "Users"
  },
  {
    id: 4,
    title: "HR Management",
    description: "Staff requisition tracking, automated onboarding workflows, credential delivery, orientation allocation, and payroll integration with biometric.",
    icon: "Briefcase"
  },
  {
    id: 5,
    title: "Staff Attendance",
    description: "Biometric integration for real-time tracking, configurable attendance rules, late/early detection, and automated absentee notifications.",
    icon: "CalendarCheck"
  },
  {
    id: 6,
    title: "Transport Module",
    description: "Route & vehicle management, student allocation, driver management, GPS tracking, and comprehensive transport expense history.",
    icon: "Bus"
  },
  {
    id: 7,
    title: "Learning Management System",
    description: "Centralized syllabus, handbooks, assessments, reference materials, report cards, marks viewing, and progress tracking.",
    icon: "BookOpen"
  },
  {
    id: 8,
    title: "Helpdesk Module",
    description: "Centralized query management for Academics, Transport & Finance with automated notifications and response workflow approval.",
    icon: "Headphones"
  },
  {
    id: 9,
    title: "Purchase & Inventory",
    description: "Purchase requests, quotation management, approval workflows, GRN generation, and unified inventory stock control.",
    icon: "Package"
  },
  {
    id: 10,
    title: "Student Survey",
    description: "Secure OTP-based feedback collection, customizable surveys, staff performance cards, and detailed analytics reporting.",
    icon: "ClipboardList"
  },
  {
    id: 11,
    title: "Online Assessment",
    description: "Secure candidate tests with timed access, diverse question types, HOD evaluations, and automated scorecards.",
    icon: "FileCheck"
  },
  {
    id: 12,
    title: "Mobile App",
    description: "Integrated access to fees, LMS, circulars, GPS tracking, attendance, leave requests, and helpdesk ticketing.",
    icon: "Smartphone"
  }
];

export const whyChoose = [
  {
    id: 1,
    title: "Easy to Use",
    description: "Intuitive interface designed for educators, not tech experts.",
    icon: "Sparkles"
  },
  {
    id: 2,
    title: "Secure & Reliable",
    description: "Bank-grade security with 99.9% uptime guarantee.",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "24/7 Support",
    description: "Dedicated support team available round the clock.",
    icon: "HeadphonesIcon"
  },
  {
    id: 4,
    title: "Customizable",
    description: "Tailored solutions to fit your school's unique needs.",
    icon: "Settings"
  }
];

export const navLinks = [
  { id: 1, label: "Home", href: "#home" },
  { id: 2, label: "Features", href: "#features" },
  { id: 3, label: "About", href: "#about" },
  { id: 4, label: "Contact", href: "#contact" }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1600792170156-7fdc12ed6733?w=1400&q=80",
  classroom: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&q=80",
  technology: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&q=80",
  campus: "https://images.unsplash.com/photo-1613896527026-f195d5c818ed?w=800&q=80",
  about: "https://images.unsplash.com/photo-1594608661623-aa0bd3a69d98?w=800&q=80",
  students: "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800&q=80"
};
